import { useEditAddressStore } from '../../../stores/edit-address-store'
import { useEffect, useMemo } from 'react'
import { filterFilledParams } from '../../../../../hooks/use-search-params'
import { useSelector } from 'react-redux'
import useAccountAddressFilter from '../../../hooks/use-account-address-filter'
import useMemberAddressData from '../../../hooks/use-member-address-data'
import EditAddressForm from './edit-address-form'
import Modal, { ModalBody } from '../../modal'

const EditAddressModal = () => {
  const { idMember } = useSelector(state => state)
  const { search, page, limit } = useAccountAddressFilter()

  const paramsMemberAddress = useMemo(
    () =>
      filterFilledParams({
        member_id: idMember,
        keyword: search,
        page,
        limit,
      }),
    [idMember, search, page, limit]
  )

  const memberAddressData = useMemberAddressData(paramsMemberAddress)
  const open = useEditAddressStore(s => s.open)
  const closeModal = useEditAddressStore(s => s.closeModal)
  const isLoading =
    memberAddressData?.isLoading || memberAddressData?.isFetching

  useEffect(() => {
    if (!open) return

    const handlePopState = () => {
      // Block back
      window.history.pushState(null, document.title, window.location.href)
    }

    window.history.pushState(null, document.title, window.location.href)
    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [open])

  return (
    <Modal
      open={open}
      onClose={closeModal}
      disabled={isLoading}
      disableOutsideClick
      header={{ text: 'Ubah Alamat' }}
    >
      <ModalBody>
        <EditAddressForm />
      </ModalBody>
    </Modal>
  )
}

export default EditAddressModal
